import { Box } from '@material-ui/core';
import red from '../../features/dossierIncapacite/assets/cloture.svg';
import ouvert from '../../features/dossierIncapacite/assets/encours2.svg';
import green from '../../features/dossierIncapacite/assets/indemnisation.svg';
import warning from '../../features/dossierIncapacite/assets/warning.svg';

export const StatusIncapiciteIcon = (value: string) => {
    let iconSrc = '';
    let label = '';

    switch (value) {
        case '3':
            iconSrc = warning;
            label = 'Alert';
            break;
        case '2':
            iconSrc = red;
            label = 'Cloture';
            break;
        case '1':
            iconSrc = green;
            label = 'Indemnisation';
            break;
        case '0':
            iconSrc = ouvert;
            label = 'En attente de traitement';
            break;
        default:
            return null;
    }

    return (
        <Box display="flex" alignItems="center">
            <img src={iconSrc} alt={label} style={{ width: '48px' }} />
        </Box>
    );
};
